@if (isInitialized) {
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title">
                Import Recalculation Errors
                <ag-grid-row-count [gridApi]="gridApi" [gridOptions]="gridOptions"></ag-grid-row-count>
            </h4>
            <div class="ws-section__header__actions">
                <div class="ws-section__header__actions__item">
                    <button type="button"
                            class="ace-btn btn-sm btn-secondary has-icon"
                            (click)="refresh()"
                            [disabled]="refreshing"
                            helpTooltip
                            helpContentId="app.refresh"
                            position="bottom">
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex filter-row">
        <div class="d-flex filter-group align-items-center">
            <label class="ws-flex-none small ws-font-weight-normal"
                   helpTooltip
                   helpContentId="import-recalculation-errors-list.include-acknowledged"
                   position="bottom">
                <input type="checkbox" [(ngModel)]="includeAcknowledged" (change)="onIncludeAcknowledgedChange()">
                Include Acknowledged Errors
            </label>
        </div>
    </div>
}
<ws-ag-grid-angular [gridOptions]="gridOptions"
                    (gridReady)="onAgGridReady($event)"
                    [gridId]="gridId">
</ws-ag-grid-angular>
